import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "signaturePaymentApp", fr_CA);
i18next.addResourceBundle("en-CA", "signaturePaymentApp", en_CA);

export const SignaturePaymentConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "SignaturePayment",
  auth: "login",
  routes: [
    {
      path: "/app/signature/:documentId?",
      component: React.lazy(() => import("./views/SignaturePayment")),
    },
  ],
};

